import {
  anAutomation,
  anUpdateAutomation,
  mockUpdateAutomationOperationMutation,
} from '__generated__';
import { mockAutomation } from 'mocks/queries/AutomationQueryOperation.mocks';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateAutomationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateAutomation: anUpdateAutomation({
            data: anAutomation({
              ...mockAutomation,
              executionTypes: [
                ...mockAutomation.executionTypes,
                'INSIGHT_CLOSED',
              ],
            }),
          }),
        },
      });
    }
  ),
];
